import React from 'react';
import { Card } from './ui/card';
import { Badge } from './ui/badge';
import { ExternalLink, CheckCircle } from 'lucide-react';
import { profileData } from '../data/mock';

const Projects = () => {
  return (
    <section id="projects" className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Featured <span className="text-[#00AFF0]">Projects</span>
          </h2>
          <div className="w-20 h-1 bg-[#00AFF0] mx-auto mb-4"></div>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Showcasing impactful solutions and innovative implementations
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {profileData.projects.map((project, index) => (
            <Card
              key={project.id}
              className="group overflow-hidden hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 border-2 hover:border-[#00AFF0]/50"
            >
              {/* Project Header with gradient */}
              <div className="h-48 bg-gradient-to-br from-[#00AFF0]/10 to-[#0099D6]/10 relative overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-br from-[#00AFF0]/20 to-transparent group-hover:scale-110 transition-transform duration-500"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-20 h-20 rounded-2xl bg-white shadow-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-500">
                    <span className="text-3xl font-bold text-[#00AFF0]">{index + 1}</span>
                  </div>
                </div>
              </div>

              {/* Project Content */}
              <div className="p-6 space-y-4">
                <div className="flex items-start justify-between gap-2">
                  <h3 className="text-xl font-bold text-gray-900 group-hover:text-[#00AFF0] transition-colors">
                    {project.title}
                  </h3>
                  <ExternalLink className="w-5 h-5 text-gray-400 group-hover:text-[#00AFF0] transition-colors flex-shrink-0" />
                </div>

                <p className="text-gray-700 leading-relaxed">{project.description}</p>

                {/* Technologies */}
                <div className="flex flex-wrap gap-2">
                  {project.technologies.map((tech, idx) => (
                    <Badge
                      key={idx}
                      variant="secondary"
                      className="bg-gray-100 text-gray-700 hover:bg-[#00AFF0]/10 hover:text-[#00AFF0] transition-colors text-xs"
                    >
                      {tech}
                    </Badge>
                  ))}
                </div>

                {/* Highlights */}
                <div className="space-y-2 pt-2 border-t border-gray-100">
                  {project.highlights.map((highlight, idx) => (
                    <div key={idx} className="flex items-start gap-2">
                      <CheckCircle className="w-4 h-4 text-[#00AFF0] mt-0.5 flex-shrink-0" />
                      <span className="text-sm text-gray-600">{highlight}</span>
                    </div>
                  ))}
                </div>
              </div>
            </Card>
          ))}
        </div>

        {/* Call to Action */}
        <div className="mt-16 text-center">
          <Card className="p-8 bg-gradient-to-r from-[#00AFF0]/5 to-[#0099D6]/5 border-2 border-[#00AFF0]/20">
            <h3 className="text-2xl font-bold text-gray-900 mb-3">
              Interested in seeing more?
            </h3>
            <p className="text-gray-700 mb-6">
              These are just a few highlights. I've worked on 50+ projects across various domains.
            </p>
            <button className="px-8 py-3 bg-[#00AFF0] text-white rounded-lg hover:bg-[#0099D6] transition-all duration-300 hover:shadow-lg hover:shadow-[#00AFF0]/30 font-semibold">
              View All Projects
            </button>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default Projects;